import { match } from 'ts-pattern'
import { enumOptionsToObject } from '../../internal'
import { CustomerOrderBookingMethod, CustomerOrderBookingMethodOptions } from './customer-order-model'

export const customerOrderBookingPlatformOptions = ['Polaris', 'Select', 'Viator'] as const
export const customerOrderBookingPlatforms = enumOptionsToObject(customerOrderBookingPlatformOptions)
export type CustomerOrderBookingPlatform = (typeof customerOrderBookingPlatformOptions)[number]

export function getBookingPlatformForBookingMethod(bookingMethod: CustomerOrderBookingMethod): CustomerOrderBookingPlatform {
  return match(bookingMethod)
    .with('adv', () => 'Polaris' as const)
    .with('advWhiteLabel', () => 'Polaris' as const)
    .with('outfitter', () => 'Polaris' as const)
    .with('select', () => 'Select' as const)
    .with('viator', () => 'Viator' as const)
    .exhaustive()
}

export function getBookingMethodsForBookingPlatform(
  bookingPlatform: CustomerOrderBookingPlatform
): CustomerOrderBookingMethod[] {
  return CustomerOrderBookingMethodOptions.filter((b) => getBookingPlatformForBookingMethod(b) === bookingPlatform)
}
